import { useEffect } from "react";
import notificationtemplates from "../notifications";

function NotificationProvider(props) {

  let mytemplate = notificationtemplates;

  useEffect(() => {
    if (props.notification) {
      // If a notification is set, start a 5-second timer
      const timer = setTimeout(() => {
        props.onRemove();
      }, 4000);

      // Cleanup the timer if the notification changes or component unmounts
      return () => clearTimeout(timer);
    }
  }, [props.notification]);

  return (
    <div className={`notificationprovider mapvisible ${props.stationopen ? "maphidden" : ""}`}>
      {Object.entries(mytemplate).map(([key, value]) => (
        <div key={"notification-" + key} className={`notification ${key == props.notification ? "notification-open" : ""}`}>
          {value.icon && <img className='notificationicon' src={value.icon} />}
          <div className="notificationtextcont">
            {value.headline && <div className="notificationheadline">{value.headline[props.lang]}</div>}
            {value.text && <div className="notificationtext">{value.text[props.lang]}</div>}
            {value.button && <div className="notificationbutton clickable" onClick={() => props.onButtonClick?.(key)}>{value.button[props.lang]}</div>}
          </div>

          <div className="notificationprogress">
            {key == props.notification && <div className="notificationprogressinner"></div>}
          </div>

        </div>
      ))}
    </div>
  );
}

export default NotificationProvider;
